export default "__VITE_ASSET__B24bhXcD__"